import HeadDetailsGama from '@/views/private/realestate/components/HeadDetails.vue'
import WorkStageEnterpriseRepository from '@/shared/http/repositories/realestate/workstageenterprise'
import workstage from '@/shared/http/repositories/realestate/workstage'
import FileEnterpriseRepository from '@/shared/http/repositories/realestate/fileenterprise'
import { toast, loading } from '@/shared/utils/UIHelper'
import Multiselect from 'vue-multiselect'
import ActionsForm from '@/shared/mixins/actionsForm'
import ExpenseMixin from '@/views/private/finance/expenses/travelexpenses/mixins/ExpenseMixin.js'

export default {
  name: 'Evolutionwork',
  components: {ActionsForm, ExpenseMixin, HeadDetailsGama, Multiselect},
  props: ['data'],
  data () {
    return {
      stage: [],
      changeAngel: false,
      changeAngel2: false,
      dataimg: [],
      liksYoutube: [],
      dataTotal: 0,
      imgobra: false,
      linkyoutube: '',
      obraArray: [],
      criar: false,
      nomeEvolucao: null,
      TipoEvolucaoArray: [],
      TiposObrasArray: []
    }
  },
  mounted () {
    this.carregarStage()
    this.getImg()
    this.getTotal()
    this.ObrasGet()
  },
  watch: {
    TipoEvolucaoArray () {
      this.TiposObrasArray = this.TipoEvolucaoArray.map(x => x.id)
    }
  },
  methods: {
    cancelar () {
      this.nomeEvolucao = null
      this.TipoEvolucaoArray = []
      this.TiposObrasArray = []
      this.$refs['add-evolucao'].hide()
    },
    addTag (newTag) {
      const tag = {
        text: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
      }
      this.options.push(tag)
      this.value.push(tag)
    },
    salvar () {
      loading.push()
      WorkStageEnterpriseRepository.SaveEmpreendimentoEtapaObra({Empreendimentoid: this.data.id, Nome: this.nomeEvolucao, EtapaObraId: this.TiposObrasArray})
        .then(Response => {
          if (Response.data === true) {
            toast.success('Etapas inseridas com sucesso')
            this.cancelar()
            this.ObrasGet()
            this.carregarStage()
          } else {
            toast.error('Erro ao inserir')
          }
          loading.pop()
        })
        .catch(Error => loading.pop())
    },
    ObrasGet () {
      loading.push()
      workstage.GetAllObra(this.data.id)
        .then(Response => {
          this.obraArray = Response.data.data
          loading.pop()
        })
        .catch(Error => loading.pop())
    },
    openEvolucao () {
      this.$refs['add-evolucao'].show()
    },
    mudarCriacao () {
      this.nomeEvolucao = null
      this.TipoEvolucaoArray = []
      this.criar = !this.criar
    },
    carregarStage () {
      loading.push()
      WorkStageEnterpriseRepository.GetAllByEmpreedimentoid(this.data.id)
        .then(Response => {
          for (let i = 0; i < Response.data.data.length; i++) {
            this.stage.push(Response.data.data[i])
          }
          loading.pop()
        })
        .catch(Error => loading.pop())
    },
    formatPercentage (value, e) {
      value = value.replace(/\D/gm, '')
      let valueInt = parseInt(value)

      if (valueInt > 100) {
        value = '100'
      }

      if (valueInt < 0) {
        value = '0'
      }

      if (value !== '' && e.inputType !== 'deleteContentBackward') {
        value += '%'
      }
      return value
    },
    removeLinkYotube (id) {
      this.liksYoutube = this.liksYoutube.filter((Element) => Element.id !== id)
    },
    addLinkYotube () {
      if (this.linkyoutube.includes('https://www.youtube.com/watch?v=')) {
        let data = {
          id: (Math.random() * 1000).toString().replaceAll('.', ''),
          link: this.linkyoutube.replace('watch?v=', 'embed/')
        }
        this.linkyoutube = ''
        this.liksYoutube.push(data)
      }
    },
    cancelLiksYoutube () {
      this.liksYoutube = []
      this.$refs['add-link-youtube'].hide()
    },
    openLinkYotube (e) {
      this.liksYoutube = []
      this.$refs['add-link-youtube'].show()
    },
    changeValor (e) {
      let valorInput = parseInt(document.getElementById('input' + e).value)
      let index = this.stage.findIndex(x => x.id === e)
      if (valorInput > 0) {
        this.stage[index].percentualPronto = valorInput
      }
    },
    getTotal () {
      loading.push()
      WorkStageEnterpriseRepository.GetTotalPercenByEmpreendimento(this.data.id)
        .then(Response => {
          this.dataTotal = Response.data
          loading.pop()
        })
        .catch(Error => {
          loading.pop()
        })
    },
    SalvarPogressao () {
      loading.push()
      WorkStageEnterpriseRepository.SalvarLista(this.stage)
        .then(Response => {
          this.getTotal()
          loading.pop()
        })
        .catch(Error => loading.pop())
    },
    addIma () {
      document.getElementById('input-build').click()
    },
    Aumentar (id) {
      let valorInput = parseInt(document.getElementById('input' + id).value)
      let index = this.stage.findIndex(x => x.id === id)
      if (valorInput < 100) {
        this.stage[index].percentualPronto = valorInput + 1
        document.getElementById('input' + id).value = valorInput + 1 + '%'
      }
    },
    getImg () {
      loading.push()
      FileEnterpriseRepository.GetAllArquivoConstructionsByEmpreendimento(this.data.id)
        .then(Response => {
          this.dataimg = Response.data.data
          loading.pop()
        })
        .catch(Error => {
          loading.pop()
        })
    },
    closeModalLink () {
      this.$refs['add-link-youtube'].hide()
    },
    computedEmbedYoutube (value) {
      return value.replace('watch?v=', 'embed/')
    },
    SendLiksYoutube () {
      this.addLinkYotube()
      loading.push()
      FileEnterpriseRepository.SendLiksYoutube(this.data.id, 9, this.liksYoutube.map((Element) => Element.link.replace('embed/', 'watch?v=')
      ))
        .then(Response => {
          loading.pop()
          this.getImg()
          this.closeModalLink()
        })
        .catch(Error => loading.pop())
    },
    Diminuir (id) {
      let valorInput = parseInt(document.getElementById('input' + id).value)
      let index = this.stage.findIndex(x => x.id === id)
      if (valorInput > 0) {
        this.stage[index].percentualPronto = valorInput - 1
        document.getElementById('input' + id).value = valorInput - 1 + '%'
      }
    },
    saveBuild (e) {
      loading.push()
      let UrlConvert = URL.createObjectURL(e.target.files[0])
      let obj = {
        data: e.target.files[0],
        url: UrlConvert
      }
      let conf = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      let img = new FormData()
      img.append('img', obj.data)
      FileEnterpriseRepository.SendImgWithEmpreendimentoidConstructions(this.data.id, img, conf)
        .then(Response => {
          this.getImg()
          loading.pop()
        })
        .catch(Error => loading.pop())
    },
    removeEnterpriseArquivo (id) {
      loading.push()
      FileEnterpriseRepository.Delete(id)
        .then(Response => {
          loading.pop()
          this.getImg()
        })
        .catch(Error => loading.pop())
    }

  }

}



// WEBPACK FOOTER //
// ./src/views/private/realestate/enterprise/components/evolutionwork/evolutionwork.js